import React, { useMemo } from 'react';
import { Context } from './context';
import { remoteHandlerFactory } from '../common/remote-handler-factory';
/**
 * Создается singleton приложения
 * @param children
 * @param context
 * @constructor
 */
export const Provider = ({ children, context = {} }) => {
    const localContext = useMemo(() => {
        var _a;
        context.remote = (_a = context.remote) !== null && _a !== void 0 ? _a : remoteHandlerFactory();
        return context;
    }, [context]);
    return React.createElement(Context.Provider, { value: localContext }, children);
};
